import React from 'react';
import { Col } from 'react-bootstrap';

const FeatureCard = (props) => {
    return (
        <Col xs={12} sm={6} md={4} lg={3} className="my-0">
            <div className="points-card" data-aos="fade-up" data-aos-duration="1500">
                <p className="point-num text-muted">{(props.index+1).toString().length==1 ? `0${props.index+1}` : props.index+1}</p>
                <div className="linear-line mb-4"></div>
                <p className="point-cont">{props.content}</p>
            </div>
        </Col>
    )
}

export default FeatureCard
